import { render, staticRenderFns } from "./study_model_proposal.vue?vue&type=template&id=6757dfa0&scoped=true&"
import script from "./study_model_proposal.vue?vue&type=script&lang=js&"
export * from "./study_model_proposal.vue?vue&type=script&lang=js&"
import style0 from "./study_model_proposal.vue?vue&type=style&index=0&id=6757dfa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6757dfa0",
  null
  
)

export default component.exports